<template>
    <div class="safetyCode">
        <div class="header">为保证您的信息安全，需要进行验证</div>
          <div class="phone-input">
          <div class="title">请输入安全码</div>
          <van-password-input
              :value="value"
              :length="4"
              :focused="showKeyboard"
              @focus="showKeyboard = true"
          />
        </div>
        <van-number-keyboard
            v-model="value"
            :show="showKeyboard"
            maxlength="4"
            theme="custom"
            extra-key=""
            close-button-text="完成"
            @close="close"
        />
    </div>
</template>

<script>
import data from '@/views/data'
import { PasswordInput, NumberKeyboard } from 'vant';
import { getInformation, getAccessKey } from "@/api/api";
export default {
    components: {
        'van-password-input': PasswordInput,
        'van-number-keyboard': NumberKeyboard
    },
    data() {
        return {
            value: '',
            showKeyboard: true
        }
    },
    computed: {
        AccessionNumber () {
            return data.AccessionNumber
        },
        key () {
            return data.key
        },
        house_id () {
            return data.house_id
        },
    },
    methods: {
        close(){
            getInformation({
                password: this.value,
                key: this.key,
                house_id: this.house_id
            }).then(res => {
                data.data = res
                data.password = this.value
                data.key = this.key
                data.house_id = this.house_id
                this.$router.push({
                  path: './',
                  query: {
                    password: this.value,
                    key: this.key,
                    house_id: this.house_id
                  }
                })
            }).catch(err => {
                console.log('err', err.response)
                const code = err.response.data.data.code
                // console.log(code)
                // console.log(111)
                if(code=== 10001 ) {
                  this.$toast({
                    message: '分享过期',
                    duration: 3000,
                  })
                }
                if(code=== 10002 ) {
                  this.$toast({
                    message: '密码错误',
                    duration: 3000,
                  })
                }
            })
        },
    },
    mounted() {

    }
}
</script>
<style lang="less">
@import 'safetyCode.less';
</style>
